import styled from "styled-components";
import { PrimaryButton } from "components/Button/style";

export const Button = styled(PrimaryButton)`
  margin-top: 1.67rem;
  width: 8rem;
  height: 2rem;
  font-size: 0.8rem;
  white-space: nowrap;
`;

export const ButtonImportar = styled(PrimaryButton)`
  width: 8rem;
  height: 2rem;
  font-size: 0.8rem;
  margin-top: 1.67rem;
`;
